import { FerryProduct } from '@/api/Cart/cart.interfaces';
import { Money } from '@libs/money/money.interfaces';
import { t } from '@shared/helpers/translation';

export const mapFerrySubLabel = (product: FerryProduct): string => {
    if (!product.Pax) {
        return '';
    }
    const tickets = product.Pax && product.Pax.length;
    return `${tickets} ${t({
        key: 'shared.ticket',
        keyPlural: 'shared.tickets',
        count: tickets,
    })}`;
};

export const mapFerryPrice = (product: FerryProduct): Money => {
    return {
        Amount: product.Price.Amount,
        Currency: product.Price.Currency,
    };
};
